const single = () => {
  const gallery = document.querySelector(".single__gallery__section");
  if (gallery) {
    console.log(gallery);
    const slider = new Swiper(gallery, {
      draggable: true,
      pagination: {
        el: ".swiper-pagination",
      },
    });
  }
};

export default single;
